var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.676,
    height: 12.676,
    viewBox: "0 0 12.676 12.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "status-online-svgrepo-com",
    d: "M76.338,70a6.183,6.183,0,0,0-3.2.87,6.284,6.284,0,0,0-2.27,2.27,6.317,6.317,0,0,0,0,6.4,6.284,6.284,0,0,0,2.27,2.27,6.317,6.317,0,0,0,6.4,0,6.284,6.284,0,0,0,2.27-2.27,6.317,6.317,0,0,0,0-6.4,6.284,6.284,0,0,0-2.27-2.27A6.183,6.183,0,0,0,76.338,70Zm0,1.592a4.647,4.647,0,0,1,2.181.531,4.755,4.755,0,0,1,1.688,1.467,4.641,4.641,0,0,1,.833,2.086H80.023a.869.869,0,0,1-.376-.1.76.76,0,0,1-.3-.243l-1.268-1.68a.3.3,0,0,0-.516,0l-2.447,3.272a.317.317,0,0,1-.516,0l-.678-.9a.819.819,0,0,0-.3-.251.8.8,0,0,0-.361-.1H71.636a4.641,4.641,0,0,1,.833-2.086,4.755,4.755,0,0,1,1.688-1.467A4.647,4.647,0,0,1,76.338,71.592Zm0,9.492a4.647,4.647,0,0,1-2.181-.531,4.755,4.755,0,0,1-1.688-1.467A4.641,4.641,0,0,1,71.636,77h1.017a.82.82,0,0,1,.376.1.9.9,0,0,1,.3.236l1.268,1.7a.317.317,0,0,0,.516,0l2.447-3.272a.3.3,0,0,1,.516,0l.678.9a.9.9,0,0,0,.3.236.8.8,0,0,0,.361.1H81.04a4.641,4.641,0,0,1-.833,2.086,4.755,4.755,0,0,1-1.688,1.467A4.647,4.647,0,0,1,76.338,81.084Z",
    transform: "translate(-70 -70)",
    fill: "#a5a7a7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIcon);
export default __webpack_public_path__ + "static/media/status-icon.073e4227fe40c445983812b1f7107963.svg";
export { ForwardRef as ReactComponent };